import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay , ModalHeader , ModalFooter } from "@chakra-ui/modal";
// import { deleteOrganization } from "api/organizations";
import { deleteOrganization } from "api/graphQL_organizations";
import Card from "components/card/custom";
import DivLoader from "components/divloader/DivLoader";
import { useState } from "react";
import { MdArrowBack, MdDelete, MdWarning } from "react-icons/md";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'
import { deleteWhiteListRecord } from "api/whiteListed";
import toast from "react-hot-toast";

const DeleteModal = ({
  id,
  fetchListData,
  heading,
  message,
  handleDelete,
  isDeleteLoading
}: {
  name: string;
  id: string;
  fetchListData: () => void;
  heading: string;
  message: string;
  handleDelete: any;
  isDeleteLoading:any;
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState<boolean>();
  const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);
  const [isDeleteLoadingData, setIsDeleteLoadingData] =  useState<boolean>(false);
  
  
    const handleDeleteData = (deleteId: string) => {
      setIsDeleteLoadingData(true);
      deleteWhiteListRecord(deleteId)
        .then((data) => {
          handleClose()
          fetchListData();
          toast.success(data?.message || "Record deleted");
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message ?? "Record deletion failed");
        })
        .finally(() => {
          setIsDeleteLoadingData(false);
        });
    };

  const handleClose = () => {
    setIsCloseModal(true)
    setTimeout(() => {
      setIsCloseModal(false)
      onClose();
    }, 300);
  };

  return (
    <>
      <Popover trigger="hover" placement="top">
        <PopoverTrigger>
          <button className="text-red-500 outline-none dark:text-gray-200" onClick={onOpen} >
            <MdDelete className="h-5 w-5 cursor-pointer" />
          </button>
        </PopoverTrigger>
        <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
          <PopoverHeader>
            <span className="text-sm font-bold text-white">
              Delete Whitelist
            </span>
          </PopoverHeader>
          <PopoverArrow className="border h-8 w-8 border-gray-700 !bg-gray-700" />
        </PopoverContent>
      </Popover>
      
      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay className="z-20" />
        <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[700px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
            isOpen && !isCloseModal ? "card-enter" : "card-exit"
          }`}>
          <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
            <MdArrowBack
              className="h-[1.9rem] mr-2 w-6 cursor-pointer text-white"
              onClick={handleClose}
            />
            {heading}
          </ModalHeader>  
          <ModalBody className="p-4">
             
              <div className="p-4 bg-yellow-50 border-l-4 border-yellow-400 text-yellow-800 rounded-md shadow-md">
                <div className="flex items-center">
                  <MdWarning className="w-6 h-6 mr-2 text-yellow-600" />
                  <span className="font-semibold">
                  {message}
                  </span>
                </div>
              
              </div>
              
           
          </ModalBody>
          <ModalFooter className="mt-[10px] p-4">
            <div className="mt-5 flex gap-2">
              <button
                onClick={handleClose}
                className="linear rounded-xl bg-indigo-600 px-5 py-2 text-white font-medium text-navy-700 outline-none transition duration-200 hover:bg-indigo-500 active:bg-indigo-500 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                // className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
              >
                Cancel
              </button>
              <button
                onClick={() => handleDeleteData(id)}
                className="linear rounded-xl bg-red-50 px-5 py-2 text-base font-medium text-red-600 outline-none transition duration-200 hover:bg-red-600/5 active:bg-red-700/5 dark:bg-red-400/10 dark:text-white dark:hover:bg-red-300/10 dark:active:bg-red-200/10"
              >
                {isDeleteLoadingData ? (
                  <DivLoader className="h-6 w-6 border-red-400" />
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </ModalFooter>
        </Card>
      </Modal>
    </>
  );
};
export default DeleteModal;
